import { render, staticRenderFns } from "./BaseEditPageDropdown.vue?vue&type=template&id=7e6ba3a5"
import script from "./BaseEditPageDropdown.vue?vue&type=script&lang=js"
export * from "./BaseEditPageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports